module.exports = __webpack_public_path__ + "images/logo_courtier_et_pret_blanc.c0e547fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/logo_courtier_et_pret_blanc.svg
// module id = 19
// module chunks = 0 1